import React, { useEffect, useMemo } from 'react';

// Короткая награда при закрытии сделки как «Выиграно»: круг с галочкой, которая рисуется за 0,3 с, и 14 конфетти бренд-цвета.
// Не показывается при prefers-reduced-motion и в упрощённом виде. Само исчезает через 1,8 с, клики не перехватывает.
export default function Celebrate({ onDone }) {
  const off = typeof window !== 'undefined' && (
    (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ||
    document.documentElement.getAttribute('data-lite') === 'true'
  );
  useEffect(() => {
    const id = setTimeout(() => onDone && onDone(), off ? 0 : 1800);
    return () => clearTimeout(id);
  }, [off, onDone]);
  const bits = useMemo(() => Array.from({ length: 14 }, (_, i) => {
    const a = (Math.PI * 2 * i) / 14 + Math.random() * 0.4;
    const d = 90 + Math.random() * 70;
    return { dx: Math.cos(a) * d, dy: Math.sin(a) * d - 20, rot: Math.round(Math.random() * 360), c: i % 3 === 0 ? 'rgb(var(--p-400))' : i % 3 === 1 ? 'rgb(var(--p-600))' : '#34d399', w: 6 + Math.round(Math.random() * 4) };
  }), []);
  if (off) return null;
  return (
    <div className="fixed inset-0 z-[75] pointer-events-none flex items-center justify-center" aria-hidden="true">
      <div className="relative w-28 h-28 rounded-full bg-status-won-bg shadow-pop flex items-center justify-center animate-pop-in">
        <svg viewBox="0 0 52 52" className="w-14 h-14" fill="none" style={{ stroke: "rgb(var(--st-won))" }} strokeWidth="5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 27l9 9 16-18" strokeDasharray="40" strokeDashoffset="40" className="animate-draw-check" />
        </svg>
        {bits.map((b, i) => (
          <span key={i} className="confetti-bit absolute left-1/2 top-1/2 rounded-sm"
            style={{ width: b.w, height: b.w * 1.6, background: b.c, '--dx': `${b.dx}px`, '--dy': `${b.dy}px`, '--rot': `${b.rot}deg` }} />
        ))}
      </div>
    </div>
  );
}
